import type { IIAMConfig } from '../../types/iam-config'
import { istioMeshApiClient } from '../api/istioMeshApiClient'
import { logger } from '../../utils/logger'

export const iamConfigService = {
  /**
   * Fetch IAM configuration from the backend (ISTIO mesh auth via istioMeshApiClient)
   */
  async fetchIAMConfig(): Promise<IIAMConfig> {
    try {
      logger.log('Fetching IAM configuration...')
      const response = await istioMeshApiClient.get<IIAMConfig>('/iam-config/v1/configs')
      logger.log('IAM configuration fetched successfully, version:', response.version)
      return response
    } catch (error) {
      logger.error('Failed to fetch IAM configuration:', error)
      throw new Error('Failed to fetch IAM configuration. Please contact the platform team.')
    }
  }
}
